export class LLMProvider {
  id?: number;
  userId?: number;
  provider?: string;
  encryptedApiKey?: string;   
  isActive?: boolean;
}
